import React, { useState} from "react";
import { Navbar, Container, Button, Offcanvas, Nav } from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import styled from "styled-components";

// Styled-components for custom styling
const StyledNavbar = styled(Navbar)`
    position: sticky;
    top: 0;
    z-index: 1020;
    /*background-color: #33691e;*/
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const CustomNavLink = styled(Nav.Link)`
    color: #fffee2;
    font-family: 'Poppins', sans-serif;
    font-weight: bold;
    font-size: 1rem;
    @media (max-width: 1200px) {
        font-size: 0.75rem;
    }

    &:hover {
        color: #56b76b;
    }
`;

const OffcanvasHeader = styled(Offcanvas.Header)`
    background-color: rgb(42,89,52);
    color: #e9ecef;
    border-bottom: 1px solid #e9ecef;
`;

const OffcanvasBody = styled(Offcanvas.Body)`
    background-color: rgb(67, 143, 83);
    color: #e9ecef;
    border-bottom: 1px solid #e9ecef;
`

const CustomButton = styled(Button)`
    background-color: #56b76b;
    border-color: #50a963;

    &:hover {
        background-color: #56b76b;
        border-color: #50a963;
        box-shadow: 2px 2px 6px #0a2b1d;
    }
`;

const CustomBrand = styled(Navbar.Brand)`
    font-family: "Great Vibes",serif;
    font-size: 1.5rem;
    color: #FFF;
    &:hover {
        color: #FFF;
        cursor:pointer;
    }
`;

export default function StickyHeader() {
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const navigate = useNavigate();

    const handleShow = () => setShowOffcanvas(true);
    const handleClose = () => setShowOffcanvas(false);

    function handleBrandClick() {
        navigate("/");
    }

    function handleNavLinkClick(target) {
        navigate(target);
    }

    return (
        <>
            <StyledNavbar expand="lg">
                <Container>
                    <CustomBrand onClick={handleBrandClick}>The Friends of Queen's Wood</CustomBrand>

                    {/* Mobile Offcanvas Button */}
                    <div className="d-lg-none">
                        <CustomButton onClick={handleShow}>Menu</CustomButton>
                    </div>

                    {/* Desktop Navigation Links */}
                    <Navbar.Collapse className="d-none d-lg-block">
                        <Nav className="ms-auto">
                            <CustomNavLink onClick={(e) => handleNavLinkClick("/")}>Home</CustomNavLink>
                            <CustomNavLink onClick={(e) => handleNavLinkClick("/news/list")}>Latest News</CustomNavLink>
                            <CustomNavLink onClick={(e) => handleNavLinkClick("/events/list")}>Upcoming Events</CustomNavLink>
                            <CustomNavLink onClick={(e) => handleNavLinkClick("/articles/list")}>About the Wood</CustomNavLink>
                            <CustomNavLink onClick={(e) => handleNavLinkClick("/static/about-the-friends")}>About the Friends</CustomNavLink>
                            <CustomNavLink onClick={(e) => handleNavLinkClick("/membership")}>Membership</CustomNavLink>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </StyledNavbar>

            {/* Offcanvas Menu */}
            <Offcanvas show={showOffcanvas} onHide={handleClose} placement="end">
                <OffcanvasHeader closeButton>
                    <Offcanvas.Title>Menu</Offcanvas.Title>
                </OffcanvasHeader>
                <OffcanvasBody>
                    <Nav className="flex-column">
                        <CustomNavLink href="/" onClick={handleClose}>
                            Home
                        </CustomNavLink>
                        <CustomNavLink href="/news/list" onClick={handleClose}>
                            Latest news
                        </CustomNavLink>
                        <CustomNavLink href="/events/list" onClick={handleClose}>
                            Upcoming events
                        </CustomNavLink>
                        <CustomNavLink href="/articles/list" onClick={handleClose}>
                            About the wood
                        </CustomNavLink>
                        <CustomNavLink href="/static/about-the-friends" onClick={handleClose}>
                            About the friends
                        </CustomNavLink>
                        <CustomNavLink href="/membership" onClick={handleClose}>
                            Membership
                        </CustomNavLink>
                        <CustomNavLink href="/volunteering" onClick={handleClose}>
                            Volunteering
                        </CustomNavLink>
                        <CustomNavLink href="/static/report-an-issue" onClick={handleClose}>
                            Report an issue
                        </CustomNavLink>               
                        <CustomNavLink href="/static/privacy-policy" onClick={handleClose}>
                            Privacy Policy
                        </CustomNavLink>               
                    </Nav>
                </OffcanvasBody>
            </Offcanvas>
        </>
    );
}
